import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'

//UI
import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

//Hook
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'
import { useCallback } from 'react'
import useZZZ6 from '../../useZZZ6'

const ZZZ6ListHeader = ({ title, handleAdd, query }) => {
  //Hooks
  const dispatch = useDispatch()
  const { useFetchAllZZZ6s, useUploadZZZ6s } = useZZZ6()

  const { data: allZZZ6sResponse } = useFetchAllZZZ6s({
    ...query,
    page: 1,
    pageSize: 0,
  })

  const uploadZZZ6s = useUploadZZZ6s()

  const handleUpload = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      await uploadZZZ6s.mutateAsync(file)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownloadAll = useCallback(() => {
    if (!allZZZ6sResponse?.data) {
      return
    }
    try {
      let excelData = []
      if (allZZZ6sResponse.data.length === 0) {
        excelData = [
          {
            ZZ6: '',
            'ZZ6 Description': '',
            'HS Code': '',
            'Country of Origin': '',
            AL: '',
            ECCN: '',
            ESN: '',
            Remarks: '',
            Category: '',
            status: '',
          },
        ]
      } else {
        excelData = allZZZ6sResponse.data.map((row) => {
          return {
            ZZ6: row.ZZ6,
            'ZZ6 Description': row.description,
            'HS Code': row.HScode,
            'Country of Origin': Array.isArray(row.country) ? row.country.join(', ') : '',
            AL: row.AL,
            ECCN: row.ECCN,
            ESN: row.ESN,
            Remarks: row.Remarks,
            Category: Array.isArray(row.Category) ? row.Category.join(', ') : '',
            status: row.isDeleted ? 'inactive' : 'active',
          }
        })
      }

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, `${title}.xlsx`)
    } catch (err) {
      console.log(err)
    }
  }, [allZZZ6sResponse?.data, title])

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>{title}</Heading>
        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownloadAll}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <Spacer />
        <Button colorScheme="blue" onClick={handleAdd}>
          Add {title}
        </Button>
      </Flex>
    </>
  )
}

export default ZZZ6ListHeader
